<template>
  <div></div> <!-- 完全空白，不显示任何内容 -->
</template>

<script>
export default {
  name: 'Empty'
};
</script>



// WEBPACK FOOTER //
// src/components/empty.vue